export default {
  allData: state => state.data,
  selectedUser: state => state.dataUsers,
  activePage: state=> state.page,
  searchString: state => state.search,
  loading: state => state.loading,
  searchText: state => state.searchText,
  searchProfile: state => state.searchProfile,
  searchDates: state => state.searchDates,
  searchStatus: state => state.searchStatus,
}
